/**
 * Width for the article header while it is pinned (`position: fixed`) on scroll-up (SNAP-2437).
 *
 * A fixed element no longer sizes to its column, so the width has to be given explicitly. It follows
 * the measured article column instead of subtracting assumed sidebar widths, which broke for the
 * logged-out shared view (no main sidebar). `fallback` covers a column that is not rendered or laid out.
 */
export const getFixedNavbarWidth = (column: HTMLElement | null | undefined, fallback: string): string => {
  const width = column?.getBoundingClientRect().width ?? 0;
  return width > 0 ? `${width}px` : fallback;
};

/** A pinned header keeps an explicit px width, so it has to be re-measured when the column resizes. */
export const syncPinnedNavbarWidth = (
  navbar: HTMLElement | null | undefined,
  column: HTMLElement | null | undefined,
  fallback: string
): void => {
  if (navbar?.style.position !== 'fixed') return;
  navbar.style.width = getFixedNavbarWidth(column, fallback);
};
